<template>
  <div class="login_container">
    <div class="login_wrapper">
      <div class="login_left">
        <div class="left_car">
          <img
            src="//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/9b4b5aed870d4c40e7e09de28a83b94e.png" />
        </div>
        <div class="left_text">
          <img src="//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/a8392c4339a359b1da4b372b10199885.png"
            alt="" />
        </div>
      </div>
      <div class="login_right">
        <div class="login_form_box">
          <div class="login_tit">
            <div class="icon_cheyun"></div>
            <div class="login_tit_text">车云-智能汽车评测系统</div>
          </div>
          <div class="login_welcome_text">欢迎登录</div>
          <div class="login_methods">
            <div :class="['login_method', 'login_yzm', login_method == 1 ? 'active' : '']"
              @click="login_method = 1; email_val = ''; email_pwd = ''">
              <div class="icon icon_yzm"></div>
              <div class="login_method_text">手机登录</div>
            </div>
            <div :class="['login_method', 'login_yx', login_method == 2 ? 'active' : '']"
              @click="login_method = 2; mobile = ''; mobileCode = '';">
              <div class="icon icon_ewm"></div>
              <div class="login_method_text">邮箱登录</div>
            </div>
          </div>
          <div class="login_form form_yzm" v-show="login_method == 1 && !wx_login">
            <div class="form_item">
              <input type="tel" maxlength="11" class="mobile" placeholder="请输入手机号" v-model.number.lazy.trim="mobile" />
            </div>
            <div class="form_item from_item_yzm">
              <input type="tel" maxlength="6" class="mobile_code input" placeholder="请输入验证码"
                v-model.number.lazy.trim="mobileCode" />
              <div class="mobile_code_btn" v-if="countDown.isFinished" @click="getMobileCode">
                发送验证码
              </div>
              <div v-else class="mobile_code_btn disabled">
                重新获取({{ countDown.duration }}s)
              </div>
            </div>
            <div class="login_btns flex">
              <div class="submit_btn" @click="submitLogin(0)">登录</div>
              <div class="login_btn" @click="wx_login = true">微信扫码登录</div>
            </div>
          </div>

          <div class="login_form form_ewm" v-show="login_method == 1 && wx_login">
            <!-- 二维码登录 -->
            <div class="form_ewm_box" id="wx_ewm"></div>
            <div class="form_ewm_text">
              <p>微信扫描二维码</p>
              <p>(用户需在后台绑定微信后再使用)</p>
            </div>
            <div class="login_btns">
              <div class="login_btn" @click="wx_login = false">手机验证码登录</div>
            </div>
          </div>

          <div class="login_form form_yx" v-show="login_method == 2">
            <div class="form_item">
              <el-input v-model="email_val" placeholder="请输入邮箱" />
            </div>
            <div class="form_item form_item_password">
              <el-input v-model="email_pwd" type="password" placeholder="请输入密码" show-password />
            </div>
            <div class="login_btns flex">
              <div class="submit_btn" @click="submitLoginEmail(0)">登录</div>
              <router-link class="login_btn" :to="{
                path: '/login/findPwd'
              }">
                找回密码
              </router-link>
              <!-- <div class="login_btn">找回密码</div> -->
            </div>
          </div>

          <div class="applyBtn" @click="visitShow = true">申请访客体验</div>
          <el-dialog custom-class="visit_dialog" v-model="visitShow" width="50%" title="申请访客体验">
            <div>
              您好，我们诚挚的邀请您体验我们的“车云-智能座舱评测云平台”，请您填写下表，我们将由专人与您沟通我们的服务
            </div>
            <div>
              <div class="visitRow">
                <div class="visitLeft">姓名<span>*</span></div>
                <div class="visitRight">
                  <input class="visitInput" v-model="visitName" />
                </div>
              </div>

              <div class="visitRow">
                <div class="visitLeft">电话<span>*</span></div>
                <div class="visitRight">
                  <input class="visitInput" v-model="visitMobile" />
                </div>
              </div>

              <div class="visitRow">
                <div class="visitLeft">邮箱<span>*</span></div>
                <div class="visitRight">
                  <input class="visitInput" v-model="visitEmail" />
                </div>
              </div>

              <div class="visitRow">
                <div class="visitLeft">公司<span>*</span></div>
                <div class="visitRight">
                  <input class="visitInput" v-model="visitCompany" />
                </div>
              </div>

              <div class="visitRow">
                <div class="visitLeft">部门<span>*</span></div>
                <div class="visitRight">
                  <input class="visitInput" v-model="visitDepartment" />
                </div>
              </div>

              <div class="visitRow">
                <div class="visitLeft">职位<span>*</span></div>
                <div class="visitRight">
                  <input class="visitInput" v-model="visitPosition" />
                </div>
              </div>

              <div class="visitRow textAreaRow">
                <div class="visitLeft">您的需求信息<span>*</span></div>
                <div class="visitRight">
                  <div class="textareaBg">
                    <textarea class="visitTextarea" v-model="visitContent"></textarea>
                  </div>
                </div>
              </div>
            </div>

            <template #footer>
              <span class="dialog-footer">
                <el-button @click="visitShow = false">取消</el-button>
                <el-button type="primary" @click="submitvisit">提交</el-button>
              </span>
            </template>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useRoute, useRouter } from "vue-router";
import { reactive, toRefs, ref, onMounted, onUnmounted } from "vue";
import { loginGetMobileCode, loginMobile, visitAdd, loginEmail } from "@/api";
import { ElMessage, ElLoading, ElDialog, ElInput, ElMessageBox } from "element-plus";
import store from "@/store";
export default {
  name: "Login",
  components: {
    ElDialog,
    ElInput
  },
  setup() {
    const router = useRouter(),
      route = useRoute(),
      from_name = route.params.from_name,
      from_path = route.params.from_path;
    const visitShow = ref(false);
    const visitName = ref("");
    const visitCompany = ref("");
    const visitDepartment = ref("");
    const visitPosition = ref("");
    const visitContent = ref("");
    const visitMobile = ref("");
    const visitEmail = ref("");
    const login_method = ref(localStorage.getItem("sign_methods") || 1);
    window.loginSuccess = (res, type = 1) => {
      localStorage.setItem("sign_methods", type);
      // 成功
      const data = {
        nickName: res.data.username,
        avatar: res.data.avatar,
        loginToken: res.data.login_token,
        username: res.data.username,
        mobile: res.data.mobile,
        failure_date: res.data.failure_date,
        role_id: res.data.role_id,
      };
      store.signIn(data, type);
      // 成功之后的分发 待完善
      if (from_name) {
        if (from_name != "login") {
          router.replace(from_path);
        } else {
          router.replace("/home")
          // if (res.data.review_report == 0 && res.data.driving_report == 1) {
          //   router.replace("/drive/rank/0");
          // } else {
          //   router.replace("/rank/0");
          // }
        }
        loading.close();
      } else {
        router.replace("/home")
      }
      // }else if (res.data.review_report == 0 && res.data.driving_report == 1) {
      //   router.replace("/drive/rank/0");
      // } else {
      //   router.replace("/rank/0");
      // }
    };
    window.loginFail = (res) => {
      wxLoginEwm();
      if (res && res.message) {
        ElMessage.error(res.message);
      } else {
        ElMessage.error("失败，请重试！");
      }
    };
    const countDown = reactive({
      timer: null,
      duration: 60,
      isFinished: true,
    }),
      telreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
      mobileCodereg = /^\d{6}$/,
      formData = reactive({
        mobile: "",
        mobileCode: "",
        account: "",
        password: "",
      }),
      getMobileCode = () => {
        if (!countDown.isFinished) {
          return;
        }
        if (!formData.mobile) {
          ElMessage.error("请输入手机号!");
          return false;
        }
        if (!telreg.test(formData.mobile)) {
          ElMessage.error("请输入正确的手机号码!");
          return false;
        }
        countDown.timer && clearInterval(countDown.timer);
        countDown.isFinished = false;
        countDown.timer = setInterval(() => {
          const time = countDown.duration--;
          if (time <= 0) {
            clearInterval(countDown.timer);
            countDown.duration = 60;
            countDown.isFinished = true;
          }
        }, 1000);
        loginGetMobileCode({
          mobile: formData.mobile,
        })
          .then((res) => {
            if (res.code == 200) {
              ElMessage.success("发送成功!");
            } else {
              // ElMessage.error(res.message || "获取验证码失败，请稍后重试!");
              countDown.timer && clearInterval(countDown.timer);
              countDown.duration = 60;
              countDown.isFinished = true;
            }
          })
          .catch(() => {
            ElMessage.error("获取验证码失败，请重试!");
            countDown.timer && clearInterval(countDown.timer);
            countDown.duration = 60;
            countDown.isFinished = true;
          });
      };
    var loading = null;
    const submitLogin = (force) => {

      if (!formData.mobile) {
        ElMessage.error("请输入手机号!");
      }
      if (!telreg.test(formData.mobile)) {
        ElMessage.error("请输入正确的手机号码!");
        return false;
      }
      if (!formData.mobileCode) {
        ElMessage.error("请输入验证码!");
        return false;
      }
      if (!mobileCodereg.test(formData.mobileCode)) {
        ElMessage.error("请输入六位数字的验证码!");
        return false;
      }
      loading = ElLoading.service({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      loginMobile({
        mobile: formData.mobile,
        verifyCode: formData.mobileCode,
        force: force
      }).then((res) => {
        if (res && res.code && res.code == 200) {
          if (res.message != 'Logged') {
            window.loginSuccess(res, 1);
            formData.mobile = "";
            formData.mobileCode = "";
          } else {
            ElMessageBox.confirm(
              '该账号已被登录，是否确认继续登录？',
              '提示',
              {
                confirmButtonText: '继续登录',
                cancelButtonText: '取消',
                type: 'warning',
              }
            )
              .then(() => {
                submitLogin(1)
              })
          }
        }
        loading.close();
      })
      // .catch(() => {
      //   loading.close();
      //   ElMessage.error("失败，请重试!");
      // });
    };
    let visitSending = 0;
    let submit_loading = null;
    const submitvisit = () => {
      if (visitSending == 0) {
        if (
          visitName.value != "" &&
          visitCompany.value != "" &&
          visitContent.value != "" &&
          visitMobile.value != "" &&
          visitDepartment.value != "" &&
          visitPosition.value != "" &&
          visitEmail.value != ""
        ) {
          submit_loading = ElLoading.service({
            target: '.visit_dialog',
            text: '正在发送申请邮件···'
          });
          visitSending = 1;
          visitAdd({
            visitName: visitName.value,
            visitCompany: visitCompany.value,
            visitContent: visitContent.value,
            visitMobile: visitMobile.value,
            visitDepartment: visitDepartment.value,
            visitPosition: visitPosition.value,
            visitEmail: visitEmail.value,
          }).then((res) => {
            visitSending = 0;
            submit_loading.close();
            if (res.code == 200) {
              ElMessage.success("提交成功!");
              visitName.value = "";
              visitCompany.value = "";
              visitContent.value = "";
              visitMobile.value = "";
              visitDepartment.value = "";
              visitPosition.value = "";
              visitEmail.value = "";
              visitShow.value = false;
            }
          }).catch(() => {
            ElMessage.error("提交异常，请稍后重试！");
            submit_loading.close();
          })
        } else {
          ElMessage.error("请完整填写申请信息");
        }
      }
    };

    const wx_login = ref(false);

    const wxLoginEwm = () => {
      window.WxLogin &&
        new window.WxLogin({
          self_redirect: true,
          id: "wx_ewm",
          appid: "wx69bd175a495a316f",
          scope: "snsapi_login",
          redirect_uri: encodeURIComponent(
            "https://ceping.cheyun.com/login_ewm"
          ),
          state: "",
          style: "white",
          href: "data:text/css;base64,LmltcG93ZXJCb3gsLndycF9jb2RlIHsgd2lkdGg6MTUycHg7fQouaW1wb3dlckJveCAucXJjb2RlIHt3aWR0aDogMTUwcHg7bWFyZ2luLXRvcDowO2JvcmRlcjoxcHggc29saWQgI0QwRDBEMH0KLmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5OiBub25lO30KLmltcG93ZXJCb3ggLmluZm8ge3dpZHRoOiAyMDBweDtkaXNwbGF5Om5vbmU7fQouaW1wb3dlckJveCAuc3RhdHVzX2ljb24ge2Rpc3BsYXk6IG5vbmV9Ci5pbXBvd2VyQm94IC5zdGF0dXMge3BhZGRpbmc6MHB4O30KLmltcG93ZXJCb3ggLnN0YXR1cyBwLC5pbXBvd2VyQm94IC5zdGF0dXMgaDR7Zm9udC1zaXplOiAxNnB4O2ZvbnQtd2VpZ2h0OiBib2xkO2NvbG9yOiAjNzFCNEZGO2xpbmUtaGVpZ2h0OiAyMnB4O3doaXRlLXNwYWNlOm5vd3JhcDt9IA==",
        });
    };

    const email_val = ref("");
    const email_pwd = ref("");
    const submitLoginEmail = (force) => {
      const myReg = /^[a-zA-Z0-9_-]+@([a-zA-Z0-9]+\.)+(com|cn|net|org)$/;
      if (!myReg.test(email_val.value)) {
        // ElMessage.warning("邮箱格式不正确！");
        // return;
      }
      if (!email_pwd.value.length) {
        ElMessage.warning("请输入密码！");
        return;
      }
      loading = ElLoading.service({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      loginEmail({
        account: email_val.value,
        password: email_pwd.value,
        force: force
      }).then(res => {
        if (res && res.code && res.code == 200) {
          if (res.message != 'Logged') {
            email_val.value = "";
            email_pwd.value = "";
            window.loginSuccess(res, 2);
          } else {
            ElMessageBox.confirm(
              '该账号已被登录，是否确认继续登录？',
              '提示',
              {
                confirmButtonText: '继续登录',
                cancelButtonText: '取消',
                type: 'warning',
              }
            )
              .then(() => {
                submitLoginEmail(1)
              })
          }
        }
        loading.close();
      })
    }
    onMounted(() => {
      wxLoginEwm();
    });
    onUnmounted(() => {
      delete window.loginSuccess;
      delete window.loginFail;
    });

    return {
      login_method,
      countDown,
      ...toRefs(formData),
      submitLogin,
      getMobileCode,
      visitShow,
      visitName,
      visitCompany,
      visitContent,
      visitDepartment,
      visitPosition,
      visitMobile,
      visitEmail,
      submitvisit,
      wx_login,
      submitLoginEmail,
      email_val,
      email_pwd,
    };
  },
};
</script>
<style lang="less" scoped>
.login_container {
  width: 100%;
  height: 100%;
  overflow: auto;

  .login_wrapper {
    width: 100%;
    height: 100%;
    min-width: 1344px;
    min-height: 756px;
    display: flex;

    .login_left {
      width: 65%;
      height: 100%;
      background: linear-gradient(270deg, #1fbcbf 0%, #76c9cc 100%);
      position: relative;

      .left_car {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 42.5%;
        height: 82%;
        min-width: 357px;
        min-height: 630px;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          object-position: left;
        }
      }

      .left_text {
        position: absolute;
        right: 10%;
        top: 50%;
        transform: translateY(-50%);
        width: 40%;
        height: 24.4%;
        min-width: 342px;
        min-height: 185px;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          object-position: center;
        }
      }
    }

    .login_right {
      width: 35%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #fff;

      .login_form_box {
        width: 310px;
        height: 520px;

        .login_tit {
          height: 90px;
          display: flex;
          align-items: center;

          .icon_cheyun {
            width: 43px;
            height: 27px;
            background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/cheyun_20220106.png) no-repeat;
            background-size: 100%;
          }

          .login_tit_text {
            height: 32px;
            font-size: 20px;
            font-weight: 400;
            line-height: 32px;
            letter-spacing: 3px;
            margin-left: 18px;
            color: #1F1F1F;
          }
        }

        .login_welcome_text {
          height: 54px;
          font-size: 22px;
          font-weight: bold;
          color: #404e5b;
          line-height: 54px;
          letter-spacing: 1px;
          margin-bottom: 20px;
        }

        .login_methods {
          height: 71px;
          display: flex;
          margin-bottom: 35px;

          .login_method {
            width: 110px;
            height: 71px;
            border-radius: 6px;
            border: 1px solid #d3d3d3;
            margin-right: 20px;
            background: #ffffff;
            padding-top: 14px;
            cursor: pointer;

            .icon {
              width: 20px;
              height: 20px;
              margin: 0 auto;

              &.icon_yzm {
                background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/dc3ab354f6e8acae42f8a1a99e36cad5.png) no-repeat center center;
                background-size: contain;
              }

              &.icon_ewm {
                background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/acd47bda727620ee678c8160ca3353d3.png) no-repeat center center;
                background-size: contain;
              }
            }

            .login_method_text {
              height: 34px;
              line-height: 34px;
              font-size: 14px;
              font-weight: 500;
              color: #858585;
              text-align: center;
            }

            &.active {
              border: 1px solid #1fbcbf;
              background: #fafdff;

              .icon {
                &.icon_yzm {
                  background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/875bb55def8c89c8faeb971dff5e7786.png) no-repeat center center;
                  background-size: contain;
                }

                &.icon_ewm {
                  background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/f89082a31846ca8996d6d74798e8557f.png) no-repeat center center;
                  background-size: contain;
                }
              }

              .login_method_text {
                color: #555d7d;
              }
            }
          }
        }

        .login_form {
          .login_btns {
            margin-top: 30px;
            align-items: center;

            .submit_btn {
              width: 133px;
              height: 47px;
              line-height: 47px;
              background: #1fbcbf;
              border-radius: 6px;
              font-size: 18px;
              font-weight: 400;
              color: #ffffff;
              text-align: center;
              cursor: pointer;
            }

            .login_btn {
              font-size: 14px;
              font-weight: 400;
              color: #A9A9A9;
              margin-left: 29px;
              text-decoration: underline;
              cursor: pointer;
              text-align: center;
            }
          }

          &.form_yzm {
            .form_item {
              width: 260px;
              height: 42px;
              background: #f4f4f4;
              border-radius: 6px;
              display: flex;
              align-items: center;

              input {
                flex-grow: 1;
                height: 100%;
                border: none;
                background: transparent;
                outline: none;
                padding-left: 33px;
                font-size: 14px;
              }

              &.from_item_yzm {
                margin-top: 22px;

                input {
                  width: 150px;
                }

                .mobile_code_btn {
                  width: 124px;
                  height: 20px;
                  text-align: center;
                  font-size: 14px;
                  font-weight: 400;
                  color: #1fbcbf;
                  border-left: 1px solid #979797;
                  cursor: pointer;

                  &.disabled {
                    color: #888;
                    cursor: none;
                  }
                }
              }
            }
          }

          &.form_ewm {
            .form_ewm_box {
              width: 152px;
              height: 152px;
              overflow: hidden;
              margin: 0 auto;
              // width: 152px;
              // height: 152px;
              // border-radius: 4px;
              // border: 1px solid #D0D0D0;
            }

            .form_ewm_text {
              font-size: 16px;
              font-weight: bold;
              color: #555;
              line-height: 22px;
              margin-top: 13px;
              text-align: center;

              p {
                &:nth-child(2) {
                  font-size: 14px;
                  font-weight: normal;
                  color: #777;
                }
              }
            }
          }
        }
      }
    }
  }
}

.applyBtn {
  margin-top: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  color: #1fbcbf;
  cursor: pointer;
  // text-decoration: underline;
}

.visitRow {
  height: 40px;
  display: flex;
  margin-top: 20px;
}

.visitTextarea {
  width: 100%;
  height: 100%;
  resize: none;
  padding: 10px;
  background-color: rgb(246, 249, 253);
  border-color: rgb(246, 249, 253);
  outline: none;
}

.textareaBg {
  height: 110px;
  background-color: rgb(246, 249, 253);
  margin-bottom: 10px;
}

.visitLeft {
  width: 20%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.visitLeft span {
  color: red;
  margin: 5%;
}

.visitRight {
  width: 80%;
}

.visitInput {
  width: 100%;
  height: 100%;
  padding: 10px;
  background-color: rgb(246, 249, 253);
  border: none;
  outline: none;
}

.textAreaRow {
  height: 110px;
}

:deep(.el-dialog) {
  max-height: 85vh;
  overflow-y: auto;
}

.form_item {
  width: 260px;
  height: 42px;
  background: #f4f4f4;
  border-radius: 6px;
  display: flex;
  align-items: center;

  &.form_item_password {
    margin-top: 22px;
  }

  :deep(.el-input) {
    width: 100%;
    height: 100%;
    background: transparent;
  }

  :deep(.el-input .el-input__inner) {
    padding-left: 33px;
    background: transparent;
    border: none;
  }
}
</style>